const BACKOFFICE_API_URL =
  process.env.REACT_APP_BACKOFFICE_API_URL || "http://localhost:3500";

function parseFilenameFromDisposition(disposition) {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      /* ignore */
    }
  }
  const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
  return asciiMatch?.[1]?.trim() || null;
}

/**
 * Descarga el informe PDF del participante (endpoint público del backoffice).
 */
export async function downloadInformePdf({
  id_encuesta,
  id_usuario,
  nombreArchivoFallback,
  errorMessage,
}) {
  const url = `${BACKOFFICE_API_URL.replace(/\/$/, "")}/gestionEncuestas/exportarInformeParticipante`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_encuesta, id_usuario }),
  });

  if (!res.ok) {
    let message = errorMessage || "Error al descargar el informe";
    try {
      const json = await res.json();
      message = json.message || message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }

  const blob = await res.blob();
  const filename =
    parseFilenameFromDisposition(res.headers.get("content-disposition")) ||
    nombreArchivoFallback ||
    "Informe_4_Creatividades.pdf";

  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
